module.exports = {
  dataLayerLoaded: 'dataLayer-loaded',
  pageLoaded: 'page-loaded',
  propertySave: 'property-save',
  carouselPropertyClicked: 'carousel-property-clicked',
  carouselPropertyHover: 'carousel-property-hover',
  photoGridPropertyClicked: 'photo-grid-property-clicked',
  photoGridPropertyHover: 'photo-grid-property-hover',
  hoverEvent: 'hover-event',
  download: 'download',
  localCompsMapClick: 'local-comps-map-click',
  similarPropertySave: 'similar-property-save',
  similarPropertiesClick: 'similar-properties-click',
  bidStatusChange: 'bid-status-change',
  confirmBid: 'confirm-bid',
  confirmProxyBid: 'confirm-proxy-bid',
  purchaseTitleReport: 'purchaseTitleReport',
  print: 'print',
  makeYourOfferPDP: 'make-your-offer-pdp',
  firstLookModal: {
    start: 'first-look-modal-start',
    step2: 'first-look-modal-step-2',
    complete: 'first-look-modal-complete',
    back: 'first-look-modal-back',
    done: 'first-look-modal-done',
  },
  matchWinningBidButtonClick: 'match-winning-bid-button-click',
  matchTheBidConfirm: 'match-the-bid-confirm',
  qualifyRemoteBidButton: 'qualify-remote-bid-button',
  offerSubmissionSubmit: 'offer-submission-submit',
  virtualPageview: 'virtual-pageview',
  sellWithUsSubmit: 'sell-with-us-submit',
  sellWithUsSkip: 'sell-with-us-skip',
  onSaveSMSAlertsBoxLoaded: 'on-save-sms-alerts-box-loaded',
  onSaveSMSSubmitClick: 'on-save-sms-submit-click',
  bidDeposit: 'bid_deposit',

  // PS specific events
  myListingsSubmitForReview: 'my-listings-submit-for-review',
  sellerEditListing: 'seller-edit-listing',
  sellerViewOffers: 'seller-view-offers',
  myOffersBuyersView: 'my-offers-buyers-view',
  setReviewOfferDate: 'set-review-offer-date',
  setReviewOfferDateConfirm: 'set-review-offer-date-confirm',
  sellerOfferReviewAccept: 'seller-offer-review-accept',
  sellerAcceptOfferConfirm: 'seller-accept-offer-confirm',
  sellerOfferReviewDecline: 'seller-offer-review-decline',
  sellerDeclineOfferConfirm: 'seller-decline-offer-confirm',
  sellerOfferReviewCounteroffer: 'seller-offer-review-counteroffer',
  sellerOfferReviewSendCounteroffer: 'seller-offer-review-send-counteroffer',
  sellerAuctionReviewUpdateReserve: 'seller-auction-review-update-reserve',
  sellerAuctionConfirmUpdate: 'seller-auction-confirm-update',
  sellerHighestBestLearnMore: 'seller-highest-best-learn-more',
  highestBestInitiateEvent: 'highest-best-initiate-event',

  // SRP specific events
  srpPropertyClick: 'srp-property-click',
  srpPropertyClickMobile: 'map-card-click-mobile',
  srpPropertySave: 'srp-property-save',
  twoClickSaveSearchStart: 'save-search-two-click-start',
  twoClickSaveSearchSuccess: 'save-search-two-click-success',
  twoClickSaveSearchClose: 'save-search-two-click-modal-close',
  oneClickSaveSearchStart: 'save-search-one-click-start',
  oneClickSaveSearchSuccess: 'save-search-one-click-success',
  oneClickSaveSearchUpdateName: 'save-search-one-click-update-name',
  oneClickSaveSearchRemove: 'save-search-one-click-remove',
  oneClickSaveSearchClose: 'save-search-one-click-modal-close',
  mapClick: 'map-click',
  mapClickMobile: 'map-click-mobile',
  mapPinHover: 'map-pin-hover',

  // Event details events
  downloadInventoryClick: 'download-inventory-click',

  // Dashboard events
  dashboardPurchaseProfilesSave: 'dashboard-purchase-profiles-save-profile',
  dashboardAlerts: 'dashboard-alerts',
  withdrawOfferClick: 'withdraw-offer-click',
  withdrawOfferConfirmClick: 'withdraw-offer-confirm-click',
  offerDashboardCounterClick: 'offer-dashboard-counter-click',
  offerDashboardAcceptClick: 'offer-dashboard-accept-click',
  offerDashboardModalAcceptClick: 'offer-dashboard-modal-accept-click',
  offerDashboardDeclineClick: 'offer-dashboard-decline-click',
  offerDashboardDeclineModalConfirmLink:
    'dashboard-decline-offer-confirm-click',
  placeRemoteBidButtonClick: 'remote-bid-hub-place-bid-click',
  confirmRemoteBidButtonClick: 'remote-bid-hub-confirm-bid',
  remoteBidPin: 'remote-bid-hub-pin',
  remoteBidUnpin: 'remote-bid-hub-unpin',

  // Seller dashboard events
  filtersUpdated: 'filters-updated',
  mapTypeUpdated: 'mapType-updated',
  tabChanged: 'tab-changed',
  editReserveToggled: 'edit-reserve-toggled',
  editContributionToggled: 'edit-reserve-toggled',

  // Agent dashboard events
  activityButtonClick: 'activity-button-click',
  agentListingSubmit: 'agent-listing-submit',

  // registration events
  reoBidderRegistrationFormSubmit: 'reo-bidder-registration-form-submit',
  addSavedPropertiesCheckbox: 'add-saved-properties-checkbox',

  // sms opt in
  accountManagementSmsOptInLoaded: 'profile-sms-alerts-box-loaded',
  accountManagementSmsOptInSubmit: 'profile-sms-submit-click',
  remoteBiddingSmsOptInLoaded: 'bidder-qualification-sms-alerts-box-loaded',
  remoteBiddingSmsOptInSubmit: 'bidder-qualification-sms-submit-click',
  fclOnlineSmsOptInLoaded: 'fcl-reg-sms-alerts-box-loaded',
  fclOnlineSmsOptInSubmit: 'fcl-reg-sms-submit-click',
  reoSmsOptInLoaded: 'sms-alerts-box-loaded',
  reoSmsOptInSubmit: 'bidder-info-sms-submit-click',
}
